export { default as AccountTabs } from './component';
